import { render, staticRenderFns } from "./embed.vue?vue&type=template&id=33f1d27c&"
import script from "./embed.vue?vue&type=script&lang=js&"
export * from "./embed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports